import type { ExerciseType } from '@/api/exercises'

/**
 * Каталог типов заданий: группировка для выбора типа в конструкторе.
 *
 * Порядок внутри групп совпадает с каталогом типов в ТЗ — учитель ищет тип
 * там же, где он описан в документации.
 */

export type ExerciseTypeGroup = 'gaps' | 'choice' | 'order' | 'text' | 'media' | 'delegate'

export const EXERCISE_TYPE_GROUPS: Record<ExerciseTypeGroup, ExerciseType[]> = {
  gaps: ['drag_gaps', 'cloze', 'dropdown_gaps'],
  choice: ['choice', 'true_false', 'picture'],
  order: ['matching', 'sentence_builder', 'ordering', 'grouping'],
  text: ['error_correction', 'translation', 'open_answer', 'oral_answer'],
  // Диктант — обычный тип со своим редактором и экраном решения: в группе «из
  // других модулей» он остался от библиотеки диктантов, которой больше нет
  media: ['crossword', 'listening', 'dictation'],
  delegate: ['card_test'],
}

/** Типы, которые проверяет учитель (автопроверка даёт лишь подсказку) */
export const TEACHER_CHECKED_TYPES: ExerciseType[] = [
  'translation',
  'open_answer',
  'oral_answer',
]

export function isTeacherChecked(type: ExerciseType): boolean {
  return TEACHER_CHECKED_TYPES.includes(type)
}
